// src/components/games/dungeon/dungeonPuzzles.ts

export function countInversions(grid: number[]): number {
  const tiles = grid.filter(tile => tile !== 0);
  let inversions = 0;
  for (let i = 0; i < tiles.length - 1; i++) {
    for (let j = i + 1; j < tiles.length; j++) {
      if (tiles[i] > tiles[j]) inversions++;
    }
  }
  return inversions;
}

export function isSolvable(grid: number[]): boolean {
  return countInversions(grid) % 2 === 0;
}

export function generateSolvablePuzzle(): number[] {
  let attempts = 0;
  let puzzle: number[];
  do {
    puzzle = [1, 2, 3, 4, 5, 6, 7, 8, 0];
    for (let i = puzzle.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [puzzle[i], puzzle[j]] = [puzzle[j], puzzle[i]];
    }
    attempts++;
    if (attempts > 1000) {
      puzzle = [1, 2, 3, 4, 5, 6, 7, 0, 8];
      break;
    }
  } while (!isSolvable(puzzle));
  return puzzle;
}

export function getValidMoves(grid: number[]): number[] {
  const emptyPos = grid.indexOf(0);
  const validMoves = [];

  if (emptyPos % 3 !== 0) validMoves.push(emptyPos - 1); // left
  if (emptyPos % 3 !== 2) validMoves.push(emptyPos + 1); // right
  if (emptyPos >= 3) validMoves.push(emptyPos - 3); // up
  if (emptyPos <= 5) validMoves.push(emptyPos + 3); // down

  return validMoves;
}

export function isPuzzleSolved(grid: number[]): boolean {
  return grid.join("") === "123456780";
}

export function slideTile(grid: number[], targetRune: number): { success: boolean; grid: number[] } {
  const blockPos = grid.indexOf(targetRune);
  const emptyPos = grid.indexOf(0);

  if (blockPos === -1) {
    return { success: false, grid };
  }

  const validMoves = getValidMoves(grid);

  if (!validMoves.includes(blockPos)) {
    return { success: false, grid };
  }

  const newGrid = [...grid];
  newGrid[emptyPos] = targetRune;
  newGrid[blockPos] = 0;

  return { success: true, grid: newGrid };
}

export function formatPuzzleDisplay(grid: number[], runes: string[]): string[] {
  return [
    "┌─────┬─────┬─────┐",
    "│ " + runes[grid[0]] + " │ " + runes[grid[1]] + " │ " + runes[grid[2]] + " │",
    "├─────┼─────┼─────┤",
    "│ " + runes[grid[3]] + " │ " + runes[grid[4]] + " │ " + runes[grid[5]] + " │",
    "├─────┼─────┼─────┤",
    "│ " + runes[grid[6]] + " │ " + runes[grid[7]] + " │ " + runes[grid[8]] + " │",
    "└─────┴─────┴─────┘"
  ];
}